export const DEFAULT_SEARCH_QUERY = '';
